import * as React from "react";

function SvgInfo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 34 34" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34 17c0 9.389-7.611 17-17 17S0 26.389 0 17 7.611 0 17 0s17 7.611 17 17zm-19.429-4.047h4.858v14.57H14.57v-14.57zm4.858-6.477h-4.857v4.857h4.857V6.476z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgInfo;
